<template>
  <div>
    <!-- 数据导出 -->
    <div class="body">
      <!-- 搜索 -->
      <div class="search" style="display: none;">
        <!-- 数据源名称 -->
        <div class="item">
          <el-input v-model="datas.val" :placeholder="$t('message.dataSourceName')"></el-input>
        </div>
        <!-- 搜索 -->
        <el-button type="primary">{{ $t('message.search') }}</el-button>
      </div>
      <!-- 列表 -->
      <div class="table">
        <ol>
          <li class="flex05">NO</li>
          <!-- 订阅完成时间 -->
          <li> {{ $t('message.subscriptionCompletionTime') }}</li>
          <!-- 数据源 -->
          <li> {{ $t('message.dataSource') }}</li>
          <!-- 部门 -->
          <!-- <li> {{ $t('message.department') }}</li> -->
          <!-- 上一次预约 -->
          <li> {{ $t('message.lastAppointment') }}</li>
          <!-- 操作 -->
          <li> {{ $t('message.operation') }}</li>
        </ol>
        <ul v-for="(item, index) in list" :key="index">
          <li class="flex05">{{ index + 1 }}</li>
          <!-- 时间选择 -->
          <li>
            {{ item.complete_at }}
          </li>
          <!-- 数据源 -->
          <li>
            {{ item.name }}
          </li>
          <!-- 部门 -->
          <!-- <li>
            {{ item.range }}
          </li> -->
          <!-- 上一次预约 -->
          <li>
            {{ item.file_name }}
            <span type="text" v-if="item.status == 1"> 已订阅 </span>
            <span type="text" v-else-if="item.status == 2"> 运行中 </span>
            <a :href="item.file" rel="noopener noreferrer" v-else-if="item.status == 3">
              <el-button type="text"> 下载
              </el-button>
            </a>
            <span type="text" v-else-if="item.status == 4"> 已失败 </span>
          </li>
          <!-- 操作 -->
          <li>
            <!-- 预约下载 -->
            <el-button type="primary" size="small" @click="downloadByAppointment(item)">
              {{ $t('message.downloadByAppointment') }}
            </el-button>
          </li>
        </ul>
      </div>
      <!-- 分页 -->
      <!-- <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[100, 50, 20, 10]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div> -->
    </div>
    <!-- 预约下载 -->
    <el-dialog :title="$t('message.downloadByAppointment')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="580px" center>
      <!-- 开始日期-->
      <el-date-picker v-model="datas.dateStart" :placeholder="$t('message.startDate')" class="Container" type="datetime"
        default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss" style="width: 220px;margin: 0 30px;">
      </el-date-picker>
      <!--  结束日期-->
      <el-date-picker v-model="datas.dateEnd" :placeholder="$t('message.dateClosed')" class="Container"
        default-time="['23:59:59']" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 220px">
      </el-date-picker>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="reserve">{{
          $t("message.ok")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      time: [],
      datas: {
      },
      total: 0,
      list: [],
      dialogVisible: false,

    };
  },
  created() {
    this.serviceList()
  },
  methods: {
    // 列表
    serviceList() {
      this.$api.roleApi.serviceList().then(res => {
        this.list = res.data
        console.log(res);
      })
    },
    // 预约下载
    downloadByAppointment(item) {
      this.datas = {
        dateStart: '',
        dateEnd: '',
        id: item.id,
      }
      this.time = []
      this.dialogVisible = true
    },
    // 下载
    reserve() {
      this.$api.roleApi.reserve(this.datas).then(res => {
        this.$message.success(res.msg)
        this.dialogVisible = false
        this.serviceList()
      })
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.orderList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.orderList();
    },
  }
}
</script>
<style lang='scss' scoped>
.search {
  display: flex;

  .item {
    margin-right: 30px;
    width: 300px;
  }
}

.table {
  margin: 20px 0;

  .flex05 {
    flex: 0.5;
  }
}
</style>